import { api, apiMipe } from '@/core/api/';

const URL = 'api/providers';

export const getMeasureCodes = () =>
  api.get(`${URL}/interventionplan/measurecodes`);

export const getCurrentPeriod = () =>
  api.get(`${URL}/interventionplan/currentperiod`);

export const getCodeExecutionLevelArchieved = () =>
  api.get(`${URL}/interventionplan/executionlevelarchieved`);

export const getInterventionPlan = (interventionPlanId) =>
  api.get(`${URL}/interventionplan/${interventionPlanId}`);

export const submitInterventionPlan = (params) =>
  api.post(`${URL}/interventionplan`, params);

export const savePlanDiscussedWithParentsFlag = (params) =>
  api.post(`${URL}/interventionplan/billing`, params);

export const deletePlanDiscussion = (interventionPlanId) =>
  api.delete(`${URL}/interventionplan/billing/${interventionPlanId}`);

export const getInterventionPlanHistory = (interventionPlanId) =>
  api.get(`${URL}/interventionplan/${interventionPlanId}/history`);

export const submitInterventionPlanSummary = (interventionPlanId, params) =>
  api.put(`${URL}/interventionplan/${interventionPlanId}/submit`, params);
export const deleteArchivement = (archivementId) =>
  api.put(`${URL}/interventionplan/deleteArchivement/${archivementId}`);

export const saveServiceResultSummary = (params) =>
  api.post(`${URL}/interventionserviceresultsummary`, params);

export const getServiceResultSummary = (params) =>
  api.get(`${URL}/interventionserviceresultsummary`, { params });

export const getServiceResultSummaryHistory = (params) =>
  api.get(`${URL}/interventionserviceresultsummary/history`, { params });

export const getEvaluationDates = (studentSieId, diciplineType) =>
  api.get(
    `${URL}/interventionserviceresultsummary/evaluationdates/${studentSieId}/${diciplineType}`
  );

export const getSpecialistInfo = (specialistId, disciplineTypeId) =>
  api.get(
    `${URL}/specialists/${specialistId}/${disciplineTypeId}/specialistLicenceInfo`
  );

export const saveDiscussedDocument = (params) =>
  api.post(`${URL}/interventionplan/discusseddocument`, params);

export const saveAchievementSummaryDocument = (params) =>
  api.post(`${URL}/interventionplan/achievementsummarydocument`, params);

export const getAchievementSummaryDocument = (
  interventionPlanId,
  documentTypeId
) =>
  api.get(
    `${URL}/interventionplan/achievementsummarydocument/${interventionPlanId}/${documentTypeId}`
  );

/**
 * get list of bank data saved by the current user logged in and specific disciplineTypeId.
 *
 * @returns  [ {id: int, name: str, measureTypeId: int }, {...} ]
 */
export const getMeasureBankByUser = (disciplineTypeId) =>
  api.get(`${URL}/interventionplan/measurebankbyuser/${disciplineTypeId}`);

/**
 * save a bank data's description for the current user logged in the app.
 * @param {*} params = {
 * mesureTypeId : int, disciplineTypeId : int, description : str }
 *
 * @returns {id: int, name: str, measureTypeId: int }
 */
export const saveMeasureBankForUser = (params) =>
  api.post(`${URL}/interventionplan/savemeasurebankforuser`, params);

export const deleteMeasureBankForUser = (id) =>
  api.delete(`${URL}/interventionplan/measurebankforuser/${id}`);

export const saveAbsence = (data) =>
  api.post(`${URL}/interventionplan/saveabsence`, data);

export const saveInterventionPlanMechanism = (
  typeId,
  relatedId,
  isElectronicSignature
) =>
  api.put(
    `${URL}/interventionplan/savenmechanism/${typeId}/${relatedId}/${isElectronicSignature}`
  );

export const saveStudentDiagnosis = async (payload) => {
  return await apiMipe.post(`api/studentreferrals/diagnosis/`, payload);
};

export const getLastDiagnosis = async (studentSieId, disciplineTypeId) => {
  return await apiMipe.get(
    `api/studentreferrals/lastdiagnosis/${studentSieId}/${disciplineTypeId}`
  );
};

export const searchDiagnosticsExcludingStudent = (studentSieId, term = '') =>
  apiMipe.get(`api/studentreferrals/${studentSieId}/diagnostics-excluding`, {
    params: { term },
  });
